// extracted by mini-css-extract-plugin
module.exports = {"details":"MealDetails_details__11uAq","detail_title":"MealDetails_detail_title__zaKz5","description":"MealDetails_description__32F1n","ingredient":"MealDetails_ingredient__M5dYo"};